import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
import { Button } from 'components/facade/button';
const ActionButton = ({ className, title, onClick, disabled, type, danger, dataCy })=>/*#__PURE__*/ _jsx(Button, {
        className: className,
        size: "small",
        type: type !== null && type !== void 0 ? type : 'text',
        onClick: onClick,
        disabled: disabled,
        danger: danger,
        "data-cy": dataCy !== null && dataCy !== void 0 ? dataCy : `action-panel.footer.btn.${title}`,
        children: title
    });
const Wrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: ${({ $reverse })=>$reverse ? 'row-reverse' : 'row'};

  ${Button} {
    padding: 0 calc(var(--spacing-05) - 1px);
    ${({ $reverse })=>!$reverse && css`
        margin-right: var(--spacing-02);
      `};
    ${({ $reverse })=>$reverse && css`
        margin-left: var(--spacing-02);
      `};

    &:last-child {
      margin: 0;
    }
  }
`;
const ActionFooterComponent = ({ className, primary, secondary, other = [], reverse })=>/*#__PURE__*/ _jsxs(Wrapper, {
        className: className,
        $reverse: !!reverse,
        "data-cy": "action-panel.footer.wrapper",
        children: [
            /*#__PURE__*/ _jsx(ActionButton, {
                dataCy: "action-panel.footer.primary-btn",
                ...primary
            }),
            secondary == null ? null : /*#__PURE__*/ _jsx(ActionButton, {
                dataCy: "action-panel.footer.secondary-btn",
                ...secondary
            }),
            other.map((action, idx)=>/*#__PURE__*/ _jsx(ActionButton, {
                    ...action
                }, idx))
        ]
    });
export const ActionFooter = styled(ActionFooterComponent)``;
